import React from "react";

export enum InputAsEnum {
  INPUT = "input",
  TEXTAREA = "textarea",
  SELECT = "select",
}

export enum InputTypeEnum {
  TEXT = "text",
  NUMBER = "number",
  PASSWORD = "password",
  EMAIL = "email",
  DATETIME_LOCAL = "datetime-local",
  DATE = "date",
  TIME = "time",
}

interface SelectOption {
  value: string | number;
  label: string;
}

interface InputFieldProps {
  name: string;
  type?: InputTypeEnum;
  value: any;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  step?: string;
  min?: string;
  max?: string;
  as?: InputAsEnum;
  rows?: number;
  options?: SelectOption[];
}

const Input: React.FC<InputFieldProps> = ({
  name,
  type = InputTypeEnum.TEXT,
  value,
  onChange,
  onBlur,
  placeholder,
  className = "",
  disabled = false,
  step,
  min,
  max,
  as = InputAsEnum.INPUT,
  rows = 3,
  options = [],
}) => {
  const isNumber = type === InputTypeEnum.NUMBER;
  const baseClassName = `
  w-full border rounded-[8px] mt-[6px] px-[16px]
  text-[#252525] border-[#F1F1F2]
  ${isNumber 
    ? "placeholder:text-[#9CA3AF] placeholder:text-sm text-[15px]" 
    : "placeholder:text-[#9CA3AF] placeholder:text-xs text-sm"}
  ${className}
`;

  if (as === InputAsEnum.TEXTAREA) {
    return (
      <textarea
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        className={`${baseClassName} p-2 h-[70px]`}
      />
    );
  }

  if (as === InputAsEnum.SELECT) {
    return (
      <select
        name={name}
        id={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        className={`${baseClassName} h-[42px] text-[#252525] appearance-none bg-white`}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%239B9B9B' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center',
          paddingRight: '40px'
        }}
      >
        {placeholder && (
          <option value="" disabled className="text-[#252525]">
            {placeholder}
          </option>
        )}
        {options.map((option) => (
          <option key={option.value} value={option.value} className="text-[#252525]">
            {option.label}
          </option>
        ))}
      </select>
    );
  }

  return (
    <input
      type={type}
      name={name}
      id={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      className={`${baseClassName} h-[42px]`}
      step={step}
      min={min}
      max={max}
    />
  );
};

export default Input;
